import * as ko from "knockout";
import {RuleMutable} from "./RuleMutable";
import {ICategory, ISelection, ISelectionType} from "./index";
import {ObjectTypeId} from "../../../constants";
import {Categories} from "./_def";
import {AvailableData} from "../mutable/rule/AvailableData";
import {RuleMutableException} from "./RuleMutableException";
import {MutableRuleset as MutableRuleset} from "../mutable/mutableRuleset";
import {IFullObjectType} from "../index";

export class Settings {
    public readonly category: KnockoutObservable<ICategory | null> = ko.observable(null);
    public readonly selectionType: KnockoutObservable<ISelectionType | null> = ko.observable(null);
    public readonly selection: KnockoutObservable<ISelection | null> = ko.observable(null);
    public readonly exception: KnockoutObservable<ISelection | null> = ko.observable(null);

    public readonly ruleMutableException: RuleMutableException;
    public readonly ruleMutableSelection: RuleMutable;

    public readonly deleted: KnockoutObservable<boolean | null> = ko.observable(null);
    public readonly isValid: KnockoutObservable<boolean | null> = ko.observable(null);

    public readonly initialObjectTypeId: ObjectTypeId;
    public readonly objectType: KnockoutObservable<IFullObjectType | null>;

    constructor(public availableData: AvailableData, public mutableRuleset: MutableRuleset) {
        this.objectType = mutableRuleset.data.objectType;
        this.ruleMutableException = new RuleMutableException(availableData, this.exception);
        this.ruleMutableSelection = new RuleMutable(availableData, this.selection);
        this.initialObjectTypeId = mutableRuleset.data.objectType()?.id ?? ObjectTypeId.User;
        this.category(Categories.find(c => c.objectTypeId == this.initialObjectTypeId) ?? null);
        this.deleted(Boolean(this.deletedPreset()));
    }

    public isUserObjects(): boolean {
        const category = this.category()
        return !!category && ['user', 'manager'].includes(category.value) && this.selectionType()?.value == 'object';
    }

    public deletedPreset(): boolean | null {
        const rm = this.mutableRuleset.data.rules().find(m => m.attribute() == 'Deleted');
        const operator = typeof rm?.argumentoperator === 'function' ? rm.argumentoperator() : undefined
        switch (operator){
            case 'Har verdi':
                return true;
            case 'Har ikke verdi':
                return false;
            default:
                return null;
        }
    }

}
